import type { SVGProps } from "react";
import * as React from "react";
const SvgFontSizeAi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="currentColor" d="M12 14H8.518v6H5.505L5.5 14H2v-3h10v3Z" />
    <path fill="currentColor" d="M22.5 7H17v13h-3V7H8.5V4h14v3Z" />
  </svg>
);
export default SvgFontSizeAi;
